import { Link } from "react-router-dom";

interface IProps {
    title: string,
    subTitle: string
}
export default function HeaderWithTitle(props: IProps) {

    return (
        <header>
            <Link to="/" className="text-secondary font-weight-bolder ml-2">preCERT®</Link>
            <br />
            <h3 className="font-weight-bolder ml-2 mt-1 mb-4">{props.title}</h3>
            {props.subTitle && 
            <h5 className=" mt-1 mb-4 ml-2">{props.subTitle}</h5>
            }
        </header>
    );
}
